import type { OasDocument3XExtended } from '@ipfabric/utils';
import type { DeviceViewElementType } from '../deviceViewTypes';

export const isValidNodeEndpoint = (
  deviceViewElement: DeviceViewElementType,
  apiEndpoint: string,
  oas: OasDocument3XExtended,
): boolean => deviceViewElement === 'node' && apiEndpoint in (oas.paths ?? {});
